import * as React from 'react'

export type Locale = 'da' | 'en' | 'gl'

export type StringProvider = (key: string) => string

const defaultLocale: Locale = 'da'

export const LocaleContext = React.createContext<{
  locale: Locale
  translate: StringProvider
}>({
  locale: defaultLocale,
  translate: (x) => x
})

type LocaleProviderProps = {
  locale: Locale
  translate: StringProvider
}

export const LocaleProvider: React.FC<LocaleProviderProps> = (props) => {
  return (
    <LocaleContext.Provider
      value={{
        locale: props.locale,
        translate: props.translate
      }}
    >
      {props.children}
    </LocaleContext.Provider>
  )
}

export type LocaleProps = {
  locale: Locale
  strings: StringProvider
}

// A HOC for the LocaleContext, inject a "locale" prop.
const withLocale = <P extends {}>(WrappedComponent: React.ComponentType<P & LocaleProps>) => (props: P) => (
  <LocaleContext.Consumer>
    {(state) => <WrappedComponent {...props} locale={state.locale} strings={state.translate} />}
  </LocaleContext.Consumer>
)

export default withLocale

export const dictionaryKeys: string[] = [
  'Vælg lokation',
  'Hvor vil du gerne booke en tid?',
  'Vælg emne',
  'Hvad vil du gerne snakke om?',
  'Vælg dato og tidspunkt',
  'Man',
  'Tirs',
  'Ons',
  'Tors',
  'Fre',
  'Lør',
  'Søn',
  'Januar',
  'Februar',
  'Marts',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'August',
  'September',
  'October',
  'November',
  'December',
  'Udfyld information',
  'Indtast fornavn',
  'Fornavn',
  'Indtast efternavn',
  'Efternavn',
  'Indtast email',
  'Email',
  'Uddannelse',
  'Vælg uddannelse',
  'Indtast mobil',
  'Mobil nr.',
  'Skal vi sende en SMS som reminder?',
  'Besked',
  'Her kan du evt. skrive en besked til studievejlederen',
  'Book tid',

  'Vælg dato og tidspunkt knap',
  'Du skal vælge både en dato og et tidspunkt',
  'Vælg en dato for at se tilgængelige tider',
  'Påkrævet',
  'Faglige udfordringer',
  'Efter- og videreuddannelse',
  'Personlige problemer',
  'Ugyldig',
  'Ja tak – send mig SMS dagen før',
  'Ledige tider d. dato',
  'Vælg'
]
